module.exports = __webpack_public_path__ + "static/media/portfolio2.ff3c3345.jpg";